import React, { memo } from "react";

import { useEffectOnce } from "@swiggy-private/core-ui";

import { Content, Footer } from "./components";

import { IOfferPackNudgeWidgetProps } from "./types";

import { getContextForActiveAnalytics, getPlanForNudgeAnalytics, isActive } from "@cart-ui/helpers/OfferBundle";

import { OFFER_BUNDLE } from "@swiggy-private/cart-test-ids";

import { StyledCardContainer } from "./styles/OfferPackNudgeWidget.styled";
import styles from "./styles/OfferPackNudgeWidget.scss";

const OfferPackNudgeWidget = ({ item, onItemClick, analyticsEvents, isOfferPackAdded }: IOfferPackNudgeWidgetProps) => {
    useEffectOnce(() => {
        if (isActive(item.meta)) {
            analyticsEvents.impressionActiveWidget(getContextForActiveAnalytics(item.meta));
            return;
        }

        analyticsEvents.impressionNudge(getPlanForNudgeAnalytics(item.meta));
        return;
    });

    if (!item) return null;

    return (
        <StyledCardContainer cornerRadius="medium" className={styles.container} data-testid={OFFER_BUNDLE.NUDGE_WIDGET}>
            <Content item={item.meta} />
            <Footer
                isOfferPackAdded={isOfferPackAdded}
                item={item}
                onItemClick={onItemClick}
                analyticsEvents={{ clickNudge: analyticsEvents.clickNudge }}
            />
        </StyledCardContainer>
    );
};

export default memo(OfferPackNudgeWidget);
